/**
 * Created by akirilyuk on 9/7/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/extendedList/ticketAttachmentView.tmpl"),
        TicketAttachmentItemView = require("connection-views/ticketTab/extendedList/TicketAttachmentItemView"),
        AttachmentsCollection = require("connection-collections/ticketTab/AttachmentsCollection"),
        BaseCollection = require("collections/BaseCollection"),
        TicketAttachmentView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketAttachmentView = Marionette.CompositeView.extend({
            template: template,
            className: 'attachment-list-wrapper',
            itemViewContainer: ".attachment-list-container",
            itemView: TicketAttachmentItemView,
            initialize: function (options) {
                this.container = options.el;
                this.type = options.type || AttachmentsCollection.TYPES.DEFAULT;
                this.originalCollection = options.collection;
                this.doFilter = options.doFilter;
                this.collection = (this.doFilter) ? this._getFilteredAttachments() : this.originalCollection;
            },
            onRender: function () {
                $(this.container).append(this.el);
                this._assignRemoveCallback();
                this.listenTo(this.originalCollection, "reset", this._onOriginalReset);
            },

            _onOriginalReset: function () {
                if(this.doFilter){
                    this.collection.reset(this.originalCollection.models.filter(function (model) {
                        return model.get("type") === this.type;
                    }, this));
                }
                this._assignRemoveCallback();
            },

            _assignRemoveCallback: function () {
                var that = this;
                this.children.each(function (child) {
                    child.setRemoveCallback(function (attachmentModel) {
                        if(that.doFilter){
                            that.originalCollection.deleteAttachment(attachmentModel);
                        }else{
                            that.collection.deleteAttachment(attachmentModel);
                        }
                    });
                });
            },

            _getFilteredAttachments: function () {
                return new BaseCollection(this.originalCollection.models.filter(function (model) {
                    return model.get("type") === this.type;
                }, this));
            }
        });
    });
    return TicketAttachmentView;
});
